export const FETCH_LOCKERS_REQUEST = 'FETCH_LOCKERS_REQUEST'
export const SET_LOCKERS_DATA = 'SET_LOCKERS_DATA'
export const FETCH_LOCKER_DETAIL_REQUEST = 'FETCH_LOCKER_DETAIL_REQUEST'
export const SET_LOCKER_DETAIL_DATA = 'SET_LOCKER_DETAIL_DATA'
